<template>
    <div>
      <div class="c-header">
        <div class="user">
          <img src="@/assets/img/userd.png"/>
          <p>未登录</p>
          <span>登录后享受更多求职服务</span>
        </div>
        <van-button type="primary" color="linear-gradient(to right top, #F69B58,#F87342)" round>立即登录</van-button>
      </div>
    </div>
</template>

<script>
    export default {
        name: "unLogin"
    }
</script>

<style lang="less" scoped>
  .c-header{
    display: flex;
    flex-direction: column;
    align-items: center;
    .user{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 0;
      img{
        margin-bottom: 18px;
        margin-left: 0;
      }
      p{
        margin-left: 0;
        font-size: 22px;
      }
      span{
        font-size: 12px;
        color:#D1E0FF;
        margin-top: 6px;
      }
    }
    button{
      padding-left: 50px;
      padding-right: 50px;
    }
  }

</style>
